var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.vehicle.stockNumber)+" - "+_vm._s(_vm.vehicle.vinNumber)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.vehicle.year)+" "+_vm._s(_vm.vehicle.make)+" "+_vm._s(_vm.vehicle.model)+" "+_vm._s(_vm.vehicle.trim)+" "),_c('br'),_vm._v(" "+_vm._s(_vm.vehicle.color)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }